import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { NetworkPoint } from 'src/apis/network-points/types';
import type { NetworkPointsRootRequest } from 'src/apis/network-points/use-network-points-root';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  networkPointsRoot: NetworkPointsRootRequest;
  networkPointUuid?: string;
};

type ExecuteProps = {
  url: string;
};

export function useNetworkPointByUuid({
  networkPointsRoot,
  networkPointUuid,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<NetworkPoint>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!networkPointsRoot.response || !networkPointUuid) return;
    const url = urlTemplate
      .parse(networkPointsRoot.response.data._links.getNetworkPointById.href)
      .expand({ uuid: networkPointUuid });
    request.execute({
      url,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointsRoot.response, networkPointUuid]);

  return request;
}
